import React from "react";
// import TextField from '@material-ui/core/TextField';
import { Button } from "@material-ui/core";
// import Box from '@material-ui/core/Box';
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { Form } from "react-final-form";
import Container from "@material-ui/core/Container";
// import { Link} from "react-router-dom";
import AppBar from "../../header/index";
// import SignInButton from "../../button/globleButtons";
import AppProvider from "../../bootstrap/index";
import clsx from "clsx";
import arrayMutators from "final-form-arrays";
import {
  ArrayInput,
  SimpleFormIterator
} from "react-admin";
// import DateFnsUtils from "@date-io/date-fns";
// import SimpleFormIterator from "./../../SimpleFormIterator/index";
// import {
//   MuiPickersUtilsProvider,
//   KeyboardDatePicker,
//   KeyboardTimePicker
// } from "@material-ui/pickers";
// import Calendar from 'material-ui/DatePicker/Calendar';
// import Calendar from "react-material-ui-calendar";
// import { Calendar } from '@material-ui/pickers'

const useStyles = makeStyles(theme => ({
  "@global": {
    body: {
      backgroundColor: theme.palette.common.white
    }
  },
  paper: {
    // marginTop: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
    // width:"370"
  },
  avatar: {
    margin: 10,
    width: 300,
    height: 60,
    // margin: theme.spacing(1),
    backgroundColor: "white"
  },
  form: {
    width: "110%", // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  },
  TextField: {
    marginTop: "10%",
    backgroundColor: "#ffffff"
  },
  coverBackgroundContainer: {
    // backgroundColor: "#F7F8F9",
    height: "100vh",
    backgroundSize: "cover",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    paddingLeft: "4%",
    paddingRight: "4%",
    paddingTop: "90px",
    paddingBottom: "20px"
  }
}));
const buttonClassname = clsx({
  // [classes.buttonSuccess]: success,
});

// MeetUpDate = moment(selectedDate).toISOString()

const MentorDefineAvaalbilty = props => {
  const classes = useStyles();

  const handleButtonClick = async (values) => {
  //  let MeetUpDate = moment(selectedDate).toISOString()
  };

  return (
    <AppProvider>
      <AppBar />
      <Container
        component="main"
        maxWidth="xm"
        style={{ background: "#ffffff", marginTop: "2%" }}
      >
        <div className={classes.paper}>
          <Typography component="h6" variant="h6" style={{ paddingTop: "40%" }}>
            Define Your Availability
          </Typography>
          {/* <div className={classes.coverBackgroundContainer}> */}
          <div>
            <Form
              onSubmit={handleButtonClick}
              mutators={{ ...arrayMutators }}
              render={() => (
                <ArrayInput source="Date" label="">
                  <SimpleFormIterator />
                </ArrayInput>
              )}
            ></Form>
          </div>
          </div>
        {/* </div> */}
        <Button
          fullWidth
          variant="contained"
          color="primary"
          type="submit"
          className={buttonClassname}
          // disabled={loading}
          onClick={() => handleButtonClick()}
        >
          Submit Schedule
        </Button>
      </Container>
    </AppProvider>
  );
};
export default MentorDefineAvaalbilty;
